// @flow
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import type { Order } from '../../../types/order'
import type { OrderCreated } from '../../../types/order-created'
import type { OrderStatus } from '../../../types/order-status'
import type { PriceSpecification } from '../../../types/price-specification'
import type { PaymentSpecification } from '../../../types/payment-specification'
import type { PropertyError } from '../../../types/validation-result'
import { buildOrder } from '../../../types/order'
import type { CombiDealDiscountSuggestion } from '../../../types/combi-deal-discount-suggestion'
import type {Shop} from '../shop/types'

export type CartState = {
  paymentTypeSelected: boolean,
  order: Order,
  customerDetailsChanged: boolean,
  orderValidationErrors: PropertyError[],
  orderCreated: ?OrderCreated,
  orderStatus: ?OrderStatus,
  priceSpecification: ?PriceSpecification,
  combiDealDiscountSuggestions: CombiDealDiscountSuggestion[],
  paymentSpecification: ?PaymentSpecification,
  payInTerms: boolean,
  shop: ?Shop
}
const state: CartState = {
  paymentTypeSelected: false,
  order: buildOrder(),
  customerDetailsChanged: false,
  orderValidationErrors: [],
  orderCreated: null,
  orderStatus: null,
  priceSpecification: null,
  combiDealDiscountSuggestions: [],
  paymentSpecification: null,
  payInTerms: false,
  shop: null
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/cart/index.js